import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"phone\"><defs><style type=\"text/css\"></style></defs><path d=\"M840.4736 930.9184l-656.9984 0.3584v-186.5472H840.448v186.1888zM183.4752 92.7232l0.0256 0.3584 657.024-0.3584-0.0256 558.9248H183.4752V92.7232zM840.448 0H183.5008C131.7888-0.0512 89.7792 41.4208 89.6 92.7232v838.5536C89.6 982.4 131.712 1024 183.5008 1024h656.9984c51.712 0.0512 93.7216-41.4208 93.9008-92.7232V92.7232C934.2208 41.4208 892.2112-0.0512 840.4736 0z\" p-id=\"2720\" fill=\"#707070\" /><path d=\"M441.6 870.4h89.6c24.7552 0 44.8-17.2032 44.8-38.4s-20.0448-38.4-44.8-38.4h-89.6c-24.7296 0-44.8 17.2032-44.8 38.4s20.0704 38.4 44.8 38.4\" p-id=\"2721\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/phone.svg
// module id = j445
// module chunks = 38